import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import '../../styles/LanguageSelector.css';

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  const handleLanguageChange = (newLanguage) => {
    changeLanguage(newLanguage);
  };

  return (
    <div className="language-selector">
      <button
        className={`language-btn ${language === 'nl' ? 'active agua-crooked-frame' : ''}`}
        onClick={() => handleLanguageChange('nl')}
        title="Nederlands"
        aria-label="Nederlands"
      >
        <img className="flag-icon" src="/images/flags/nl.svg" alt="" width="9" height="6" />
      </button>
      <button
        className={`language-btn ${language === 'en' ? 'active agua-crooked-frame' : ''}`}
        onClick={() => handleLanguageChange('en')}
        title="English"
        aria-label="English"
      >
        <img className="flag-icon" src="/images/flags/gb.svg" alt="" width="60" height="30" />
      </button>
    </div>
  );
};

export default LanguageSelector;
